import TableHeaders from '@/routers/views/setup/roster-setup/roster-views/roster-table-fields';

export const ROSTER_GROUPS = [
    {
        name: 'country',
        classNames: 'country-selection',
        key: 'country',
        list: [],
    },
    {
        name: 'state',
        classNames: 'state-selection',
        key: 'state',
        cardName: 'Districts',
        list: [],
        apiKey: 'districtList',
    },
    {
        name: 'district',
        classNames: 'district-selection',
        key: 'school_district',
        list: [],
        cardName: 'Schools',
        apiKey: 'fetchSchoolList',
        tableFieds: new TableHeaders('district').fields,
    },
    {
        name: 'school',
        classNames: 'school-selection',
        key: 'school',
        list: [],
        cardName: 'Classes',
        apiKey: 'fetchClassesList',
        tableFieds: new TableHeaders('school').fields,
    },
    {
        name: 'classes',
        classNames: 'class-selection',
        key: 'classes',
        list: [],
        cardName: 'Users',
        apiKey: 'fetchUsersList',
        tableFieds: new TableHeaders('classes').fields,
    },
    {
        name: 'users',
        classNames: 'user-selection',
        key: 'users',
        isHidden: true,
        list: [],
        tableFieds: new TableHeaders('users').fields,
    },
];

export const ROSTER_UPLOADS_CONSTANTS = [
    {
        name: 'Organisation',
        errorKey: 'orgs_errors',
        recordKey: 'orgs',
    },
    {
        name: 'Users',
        errorKey: 'users_errors',
        recordKey: 'users',
    },
    // {
    //     name: 'Manifest',
    //     errorKey: 'manifest_errors',
    //     recordKey: 'manifest',
    // },
    {
        name: 'Classes',
        errorKey: 'classes_errors',
        recordKey: 'classes',
    },
    {
        name: 'Courses',
        errorKey: 'courses_errors',
        recordKey: 'courses',
    },
    {
        name: 'Enrollments',
        errorKey: 'enrollments_errors',
        recordKey: 'enrollments',
    },
    // {
    //     name: 'Academic Sessions',
    //     errorKey: 'academicsessions_errors',
    //     recordKey: 'academicSessions',
    // },
];

export const ROSTER_STATUS = [
    {
        name: 'Active',
        key: 'active',
    },
    {
        name: 'Inactive',
        key: 'tobedeleted',
    },
];

export const USERS_FILTERS = [
    {
        name: 'Teachers',
        key: 'teacher',
    },
    {
        name: 'Students',
        key: 'student',
    },
    {
        name: 'Others',
        key: 'other',
    },
];
